import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SignalService {
    // UTILS
    lastPathCalled = signal('');
    // MANEJOR DE ERRORES EN RESPUESTA DE SERVICIOS
    createPasswordError = signal(false);
}